import { render, staticRenderFns } from "./RisuKumaView.vue?vue&type=template&id=c585492c&scoped=true&"
import script from "./RisuKumaView.vue?vue&type=script&lang=js&"
export * from "./RisuKumaView.vue?vue&type=script&lang=js&"
import style0 from "./RisuKumaView.vue?vue&type=style&index=0&id=c585492c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c585492c",
  null
  
)

export default component.exports